import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { FraudReportModal } from './FraudReportModal';
import type { FraudReport } from '../../services/fraud-reports.service';

interface FraudBadgeProps {
  reports: FraudReport[];
  contestantName: string;
}

export function FraudBadge({ reports, contestantName }: FraudBadgeProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Temporalmente oculto
  return null;

  if (!reports || reports.length === 0) {
    return null;
  }

  const totalAccounts = reports.reduce((sum, r) => sum + (r.accounts_detected || 0), 0);
  const totalPoints = reports.reduce((sum, r) => sum + (r.points_removed || 0), 0);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="w-full flex items-center gap-1.5 px-2 py-1.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-md hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors cursor-pointer"
      >
        <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
        <span className="text-xs text-amber-700 dark:text-amber-300 font-medium">
          Intento de fraude con multicuentas
        </span>
        <span className="text-xs text-amber-600 dark:text-amber-400 ml-auto font-semibold">
          Ver más
        </span>
      </button>

      <FraudReportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        reports={reports}
        contestantName={contestantName}
        totalAccounts={totalAccounts}
        totalPoints={totalPoints}
      />
    </>
  );
}
